module.exports = __webpack_public_path__ + "static/img/img_solution_case.77f3fd9.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobile/msolution/img_solution_case.png
// module id = tsy1
// module chunks = 0